import { openFileExplorer } from "client/Misc/domUtils";
import { useMemo } from "react";

export type FileSelectorOptions = {
	isMultiple: boolean;
	onChange(...files: readonly File[]): void;
	contentTypes?: readonly string[];
};

export type FileSelectorHandlers = {
	open(): void;
};

export function useFileSelector(options: FileSelectorOptions): FileSelectorHandlers {
	const {
		contentTypes,
		onChange,
		isMultiple
	} = options;

	return useMemo(
		(): FileSelectorHandlers => {
			return {
				open: async (): Promise<void> => {
					const result: TryResult<readonly File[]> = await openFileExplorer(contentTypes, isMultiple);

					if (result.wasSuccessful) {
						onChange(...result.result);
					}
				},
			};
		},
		[
			contentTypes,
			isMultiple,
			onChange
		]
	);
}